"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conflictParamsHasServerItemAndUnsavedItem = conflictParamsHasServerItemAndUnsavedItem;
exports.conflictParamsHasOnlyServerItem = conflictParamsHasOnlyServerItem;
exports.conflictParamsHasOnlyUnsavedItem = conflictParamsHasOnlyUnsavedItem;
function conflictParamsHasServerItemAndUnsavedItem(params) {
    return params.server_item !== undefined && params.unsaved_item !== undefined;
}
function conflictParamsHasOnlyServerItem(params) {
    return params.server_item !== undefined;
}
function conflictParamsHasOnlyUnsavedItem(params) {
    return params.unsaved_item !== undefined;
}
